"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInstructionsEdit = void 0;
const react_1 = require("react");
const cache_1 = require("../../../../../../client/cache");
const use_update_priority_task_hook_1 = require("../../../../../../../../client/priority-task/hooks/use-update-priority-task.hook");
const hooks_1 = require("../../../../../../../../../hooks");
const localization_1 = require("../../../../../../../../../localization");
const store_1 = require("../../../../../../../../../store");
const useInstructionsEdit = ({ instructions, instructionsUpdatedAt, productTreeNodeId, productLabelValidationId, queryVariables, }) => {
    const catalogId = (0, store_1.useSelectedCatalogId)();
    const productTreeId = (0, store_1.useProductTreeId)();
    const { updatePriorityTask } = (0, use_update_priority_task_hook_1.useUpdatePriorityTask)();
    const { addError } = (0, hooks_1.useNotification)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const initialValue = instructions !== null && instructions !== void 0 ? instructions : '';
    const [isEditing, setIsEditing] = (0, react_1.useState)(false);
    const [draftValue, setDraftValue] = (0, react_1.useState)(initialValue);
    const textareaRef = (0, react_1.useRef)(null);
    // Keep draft in sync with server value while not editing
    (0, react_1.useEffect)(() => {
        if (!isEditing) {
            setDraftValue(initialValue);
        }
    }, [initialValue, isEditing]);
    const startEditing = (0, react_1.useCallback)(() => {
        setIsEditing(true);
        // Focus on next tick so the textarea is no longer readOnly
        requestAnimationFrame(() => {
            var _a;
            (_a = textareaRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        });
    }, []);
    const cancel = (0, react_1.useCallback)(() => {
        setIsEditing(false);
    }, []);
    const save = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        if (!catalogId || !productTreeId || !productTreeNodeId || !productLabelValidationId || !queryVariables)
            return;
        try {
            const result = yield updatePriorityTask({
                catalog: catalogId,
                productTreeId,
                productTreeNodeId,
                productLabelValidationId,
                clientMutationId: '',
                instructions: draftValue,
            }, {
                optimisticResponse: {
                    updatePriorityTask: {
                        __typename: 'UpdatePriorityTaskPayload',
                        success: true,
                        error: null,
                        instructions: draftValue,
                        instructionsUpdatedAt: instructionsUpdatedAt !== null && instructionsUpdatedAt !== void 0 ? instructionsUpdatedAt : null,
                        assignedTo: null,
                        clientMutationId: '',
                        dateAssigned: null,
                        taskCount: null,
                        target: null,
                        priority: null,
                        status: null,
                        escalationReason: null,
                    },
                },
                update: (cache, { data }) => {
                    var _a;
                    const updatePriorityTaskResult = data === null || data === void 0 ? void 0 : data.updatePriorityTask;
                    if (!(updatePriorityTaskResult === null || updatePriorityTaskResult === void 0 ? void 0 : updatePriorityTaskResult.success))
                        return;
                    const newInstructions = (_a = updatePriorityTaskResult.instructions) !== null && _a !== void 0 ? _a : null;
                    const newTimestamp = updatePriorityTaskResult.instructionsUpdatedAt
                        ? String(updatePriorityTaskResult.instructionsUpdatedAt)
                        : null;
                    (0, cache_1.updateHLQATaskDetailsInCache)(cache, queryVariables, {
                        instructions: newInstructions,
                        instructionsUpdatedAt: newTimestamp,
                    });
                },
            });
            if ((_b = (_a = result.data) === null || _a === void 0 ? void 0 : _a.updatePriorityTask) === null || _b === void 0 ? void 0 : _b.success) {
                setIsEditing(false);
                return;
            }
            addError(t({ key: 'GENERAL_ERROR_MESSAGE' }));
        }
        catch (_c) {
            // Keep editor open on mutation errors so user can retry.
            addError(t({ key: 'GENERAL_ERROR_MESSAGE' }));
        }
    }), [
        catalogId,
        productTreeId,
        productTreeNodeId,
        productLabelValidationId,
        draftValue,
        instructionsUpdatedAt,
        updatePriorityTask,
        queryVariables,
        addError,
        t,
    ]);
    const handleBlur = (0, react_1.useCallback)(() => {
        if (!isEditing)
            return;
        if (draftValue !== initialValue) {
            void save();
        }
        else {
            setIsEditing(false);
        }
    }, [isEditing, draftValue, initialValue, save]);
    const handleChange = (0, react_1.useCallback)((e) => {
        setDraftValue(e.target.value);
    }, []);
    return {
        isEditing,
        draftValue,
        textareaRef,
        startEditing,
        cancel,
        save,
        handleBlur,
        handleChange,
    };
};
exports.useInstructionsEdit = useInstructionsEdit;
